import {
  accessing_network,
  accessing_network_light_green,
  building_support_light_green,
  gain_clarity,
  gain_clarity_light_green,
  logo_flow_light_green,
  power_in_numbers,
  primum_logo,
  sharing_information_light_green,
} from '@/assets/animations';

/**
 * Every Rive animation the app plays, bundled from `assets/animations/` rather than
 * fetched from Rive's CDN, so none depends on the Rive account or the network.
 *
 * The values are Metro asset ids. Changing an animation means replacing its file and
 * shipping the change in a reviewed PR. `FEEDBACK_SUCCESS` and
 * `SHARING_INFORMATION_LIGHT_GREEN` are the same file under two names.
 */
export const RIVE_ANIMATIONS = {
  ACCESSING_NETWORK: accessing_network,
  ACCESSING_NETWORK_LIGHT_GREEN: accessing_network_light_green,
  BUILDING_SUPPORT_LIGHT_GREEN: building_support_light_green,
  FEEDBACK_SUCCESS: sharing_information_light_green,
  GAIN_CLARITY: gain_clarity,
  GAIN_CLARITY_LIGHT_GREEN: gain_clarity_light_green,
  LOGO_FLOW_LIGHT_GREEN: logo_flow_light_green,
  POWER_IN_NUMBERS: power_in_numbers,
  PRIMUM_LOGO: primum_logo,
  SHARING_INFORMATION_LIGHT_GREEN: sharing_information_light_green,
} as const;

export type RiveAnimationName = keyof typeof RIVE_ANIMATIONS;

export type RiveAnimationSource = (typeof RIVE_ANIMATIONS)[RiveAnimationName];
